import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { store } from './store';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material';
import { theme } from './theme/theme';

/* This code is rendering the React application to the DOM. */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
    <App/>
    </ThemeProvider>
  </Provider>
);
